var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSkip(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "26px",
    height: "14px",
    viewBox: "0 0 26 14",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Skip") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "April-2020---Calculator-Solutions,-Skip-Hire-Header-Variations",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Skip-Hire-Header-Variation-3",
    transform: "translate(-747.000000, -372.000000)",
    fillRule: "nonzero",
    stroke: "#000",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("g", {
    id: "Skip",
    transform: "translate(748.000000, 373.000000)"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-1",
    points: "1.19160156 3.30050843 3.78501948 11.9705646 19.8149805 11.9705646 22.3382813 3.30050843"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-2",
    points: "0 0.30050843 0.364765574 3.30050843 23.2352344 3.30050843 23.6 0.30050843"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSkip);
export default __webpack_public_path__ + "static/media/skip.5b21ad5a7473f1c78d7beb8b4b1c584d.svg";
export { ForwardRef as ReactComponent };